import { render } from "./ViewStaff.vue?vue&type=template&id=25084f4b"
import script from "./ViewStaff.vue?vue&type=script&lang=js"
export * from "./ViewStaff.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__